import React from 'react'

import * as style from './style.module.sass'

export type CategoryTitleProps = {
  title: string
  subTitle?: string
}

const CategoryTitle: React.FC<CategoryTitleProps> = ({
  title,
  subTitle = 'CATEGORY',
}) => (
  <header className={style.titleContainer}>
    <div>{subTitle}</div>
    <h1 className={style.title}>{title}</h1>
  </header>
)

export default CategoryTitle
